export default __webpack_public_path__ + "static/media/worklogo.55414d1b.png";